import React, { Component } from 'react';
import {createBrowserHistory} from 'history';
import {BrowserRouter as Router, Route} from 'react-router-dom';

export class Menu extends Component {
    render() {
        return (
            <nav id="menu" role="navigation" className="menu">
                <ul>
                    <li className="menu-hasdropdown">
                        <a href={process.env.PUBLIC_URL + '/'} className="mega-menu-link">Home</a>
                    </li>
                    <li className="menu-hasdropdown"><a>pages</a>
                        <ul className="menu-dropdown">
                            <li><a href={process.env.PUBLIC_URL + '/aboutus_01'}>About Us 1</a></li>
                            <li><a href={process.env.PUBLIC_URL + '/Services_01'}>Services</a></li>
                            <li><a href={process.env.PUBLIC_URL + '/Our_team'}>Our Team</a></li>
                            <li><a href={process.env.PUBLIC_URL + '/team_detail'}>Team Detail</a></li>
                            <li><a href={process.env.PUBLIC_URL + '/Error'}>Error Page</a></li>
                        </ul>
                    </li>
                    <li className="menu-hasdropdown"><a>services</a>
                        <ul className="menu-dropdown">
                            <li><a href={process.env.PUBLIC_URL + '/content_engineering'}>Content Engineering</a></li>
                            <li><a href={process.env.PUBLIC_URL + '/experience_design'}>Experience Design</a></li>
                        </ul>
                    </li>
                    <li className="menu-hasdropdown"><a>Projects</a>
                        <ul className="menu-dropdown">
                            <li><a href={process.env.PUBLIC_URL + '/project_style1'}>Project Style 1</a></li>
                            <li><a href={process.env.PUBLIC_URL + '/project_style2'}>Project Style 2</a></li>
                            <li><a href={process.env.PUBLIC_URL + '/project_details'}>Project Details</a></li>
                        </ul>
                    </li>
                    <li className="menu-hasdropdown"><a>Blog</a>
                        <ul className="menu-dropdown">
                            <li><a href={process.env.PUBLIC_URL + '/blog'}>Blog Classic</a></li>
                            <li><a href={process.env.PUBLIC_URL + '/single_blog'}>Blog Single View</a></li>
                        </ul>
                    </li>
                    <li className="menu-hasdropdown">
                        <a href={process.env.PUBLIC_URL + '/contact_01'} className="mega-menu-link">Contact Us</a>
                    </li>
                </ul>
            </nav>
    
            )
    }
}